import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";

import Frame1 from "../../../assets/images/public-pages/Frame1.svg";
import Frame2 from "../../../assets/images/public-pages/Frame2.svg";
import Frame3 from "../../../assets/images/public-pages/Frame3.svg";
import Frame4 from "../../../assets/images/public-pages/Frame4.svg";
import Frame5 from "../../../assets/images/public-pages/Frame5.svg";
import Frame6 from "../../../assets/images/public-pages/Frame6.svg";
import Frame7 from "../../../assets/images/public-pages/Frame7.svg";
import Frame8 from "../../../assets/images/public-pages/Frame8.svg";
import Frame9 from "../../../assets/images/public-pages/Frame9.svg";
import Frame10 from "../../../assets/images/public-pages/Frame10.svg";
import Frame11 from "../../../assets/images/public-pages/Frame11.svg";
import Frame12 from "../../../assets/images/public-pages/Frame12.svg";
import Frame13 from "../../../assets/images/public-pages/Frame13.svg";
import Frame14 from "../../../assets/images/public-pages/Frame14.svg";
import Frame15 from "../../../assets/images/public-pages/Frame15.svg";
import Frame16 from "../../../assets/images/public-pages/Frame16.svg";
import Frame17 from "../../../assets/images/public-pages/Frame17.svg";
import Frame18 from "../../../assets/images/public-pages/Frame18.svg";
import Frame19 from "../../../assets/images/public-pages/Frame19.svg";
import Speaking from "../../../assets/images/public-pages/speaking-mastery.png";
import Writing from "../../../assets/images/public-pages/90-listening.png";
import Reading from "../../../assets/images/public-pages/reading-techniques.png";
import Listening from "../../../assets/images/public-pages/accuracy-drills.png";
import ProvenResult from "../../../assets/images/public-pages/proven-result.svg";
import ExpertFaculty from "../../../assets/images/public-pages/expert-faculty.svg";
import Learning from "../../../assets/images/public-pages/learning.svg";
import Screening from "../../../assets/images/public-pages/Screening.svg";
import IconCall from "../../../assets/images/public-pages/blue-call.svg";
import IconEmail from "../../../assets/images/public-pages/blue-email.svg";
import IconChats from "../../../assets/images/public-pages/blue-chats.svg";
import IconLocation from "../../../assets/images/public-pages/blue-location.svg";
import IconClock from "../../../assets/images/public-pages/blue-clock.svg";
import IconInfo from "../../../assets/images/public-pages/blue-info.svg";
import Document from "../../../assets/images/public-pages/grey-doc.svg";
import GreenDocument from "../../../assets/images/public-pages/green-doc.svg";

import "../../../assets/css/pte-responsive.css";
import Immigration from "../../../assets/images/public-pages/victoria-take-test.png";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import TestSection from "components/PublicPagesReusable/TestSection";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import Footer from "../Footer";
import Header from "../Header";
import ReusableHomePageSlider from "page/ReusableHomePageSlider";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";
import HeroSectionUpdated from "components/PublicPagesReusable/HeroSectionUpdated";
import PteConsultation from "components/PublicPagesReusable/PteConsultation";
import CTAContactSection from "components/PublicPagesReusable/CTAContactSection";
import CourseCard from "components/PublicPagesReusable/CourseCard";
import TickCircle from "../../../assets/images/public-pages/green-tick-circle.png"
import Profile from "../../../assets/images/public-pages/grey-profile.svg";

const images = [
  { src: Frame1, alt: "score-1" },
  { src: Frame2, alt: "score-2" },
  { src: Frame3, alt: "score-3" },
  { src: Frame4, alt: "score-4" },
  { src: Frame5, alt: "score-5" },
  { src: Frame6, alt: "score-6" },
  { src: Frame7, alt: "score-7" },
  { src: Frame8, alt: "score-8" },
  { src: Frame9, alt: "score-9" },
  { src: Frame10, alt: "score-10" },
  { src: Frame11, alt: "score-11" },
  { src: Frame12, alt: "score-12" },
  { src: Frame13, alt: "score-13" },
  { src: Frame14, alt: "score-14" },
  { src: Frame15, alt: "score-15" },
  { src: Frame16, alt: "score-16" },
  { src: Frame17, alt: "score-17" },
  { src: Frame18, alt: "score-18" },
  { src: Frame19, alt: "score-19" },
];

const heroDescriptionSection = () => (
  <p className="sub-title text-center FS16FW500">
    Whether you are in Sydney, Parramatta, Liverpool, Blacktown, Penrith, Newcastle, Wollongong
    <br /> & regional New South Wales, our PTE coaching delivers expert-led training in both classroom and online formats.
  </p>
);

const contentSection = () => (
  <h3 className="top-section-text FS40FW600">
    Transform Your Future with<br />
    <span className="text-success FS40FW600">Premier PTE Coaching Classes in NSW</span>
  </h3>
);

const skillAreaTitle = () => (
  <h3 className="top-section-text mb-4 white FS40FW600">
    Learn With <span className="text-success FS40FW600">Language Academy <br /></span> -
    Watch Our Tutorials
  </h3>
);

const lifestyleCards = [
  {
    title: "Speaking Mastery ",
    color: "transparent",
    img: Speaking,
    width: "100%",
    height: "100%",
    transform: " rotate(-5deg)",
    videoUrl: "3rRY96mbizY",
  },
  {
    title: "PTE 90/90 Method",
    color: "transparent",
    img: Writing,
    width: "100%",
    height: "100%",
    transform: " rotate(-5deg)",
    videoUrl: "t4oyY3EPYGQ",
  },
  {
    title: "Secret Scoring Guide",
    color: "transparent",
    img: Reading,
    width: "100%",
    height: "100%",
    transform: " rotate(-5deg)",
    videoUrl: "IPy4d8zzV2U",
  },
  {
    title: "Writing Mistakes and their Fix",
    color: "transparent",
    img: Listening,
    width: "100%",
    height: "100%",
    transform: " rotate(-5deg)",
    videoUrl: "U8yBis5fGn0",
  },
];

const skillAreaTitle2 = () => (
  <h3 className="top-section-text FS40FW600">
    Why We're Recognised as the<br />
    <span className="text-success FS40FW600">Best PTE Institute in NSW</span><br />
  </h3>
);

const skillAreaTitle3 = () => (
  <h3 className="top-section-text FS40FW600">
    Comprehensive PTE Course Features -<br />
    <span className="text-success FS40FW600">Everything You Need to Succeed</span><br />
  </h3>
);

const skillAreaTitle4 = () => (
  <h3 className="top-section-text FS40FW600">
    Strategic Score Targets:<br />
    <span className="text-success FS40FW600">Tailored Pathways for NSW Students</span>
  </h3>
);

const styleCards = [
  {
    title: "Proven Track Record",
    text: (
      <ul className="feature-list plus-sans FS16FW500 fw-400">
        <li><span className="fw-800">50,000+</span> successful students across NSW</li>
        <li>Average score improvement of <span className="fw-800">20+ points</span></li>
        <li>Specialised coaching for<span className="fw-800"> 50+, 60+, 75+</span> targets</li>
      </ul>
    ),
    color: "#141414",
    img: ProvenResult,
    boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Expert Faculty Team",
    text: (
      <ul className="feature-list plus-sans FS16FW500 fw-400">
        <li>Certified <span className="fw-800">PTE trainers</span> with advanced qualifications</li>
        <li>Regular training updates on the <span className="fw-800">latest PTE patterns</span></li>
        <li><span className="fw-800">Personal mentorship</span> for each student's unique needs</li>
      </ul>
    ),
    color: "#141414",
    img: ExpertFaculty,
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Strategic Locations",
    text: (
      <ul className="feature-list plus-sans FS16FW500 fw-400">
        <li>Physical centre in <span className="fw-800">Parramatta</span></li>
        <li><span className="fw-800">Live online classes</span> serving the whole world</li>
        <li><span className="fw-800">State-of-the-art facilities </span> with the latest technology</li>
      </ul>
    ),
    color: "#141414",
    img: Learning,
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Comprehensive Resources",
    text: (
      <ul className="feature-list plus-sans FS16FW500 fw-400">
        <li>Updated curriculum aligned with the <span className="fw-800">current PTE format</span></li>
        <li><span className="fw-800">AI-powered practice platforms</span> for realistic preparation</li>
        <li>Extensive question banks <span className="fw-800">with detailed explanations</span></li>
      </ul>
    ),
    color: "#141414",
    img: Screening,
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
];

const styleCards2 = [
  {
    title: "Premium Study Materials ",
    greenTitle: "MATERIALS",
    text: (
      <ul className=" plus-sans FS16FW500 fw-400 px-0">
         <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" />Latest PTE templates for all question types</li>
         <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" />Comprehensive web portal with 1,000+ practice questions</li>
         <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>Video lesson library covering advanced techniques</li>
         <li className="d-flex align-items-start gap-2"><img src={TickCircle} alt="Check" className="list-data" />Mobile app access for on-the-go learning</li>
      </ul>
    ),
    color: "#141414",
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Realistic Mock Tests & Assessment ",
    greenTitle: "ANALYTICS",
    text: (
      <ul className="plus-sans FS16FW500 fw-400 px-0">
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" />Computer-delivered practice tests mimicking the actual PTE</li>
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" />Detailed score reports with section-wise analysis</li>
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" />AI-powered feedback for continuous improvement</li>
        <li className="d-flex align-items-start gap-2"><img src={TickCircle} alt="Check" className="list-data" />Weekly progress tracking with personalised recommendations</li>
      </ul>
    ),
    color: "#141414",
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "World-Class Training Team ",
    greenTitle: "SESSIONS",
    text: (
      <ul className="plus-sans FS16FW500 fw-400 px-0">
         <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" />Native English speakers with PTE expertise</li>
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" />Individual attention in small batch sizes</li>
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" />Regular doubt-clearing sessions</li>
        <li className="d-flex align-items-start gap-2"><img src={TickCircle} alt="Check" className="list-data" />Success coaching beyond language skills</li>
      </ul>
    ),
    color: "#141414",
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Flexible Learning Options ",
    greenTitle: "FLEXIBILITY",
    text: (
      <ul className="plus-sans FS16FW500 fw-400 px-0">
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data" />Live interactive sessions via advanced platforms</li>
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>Recorded class access for revision</li>
        <li className="d-flex align-items-start gap-2"><img src={TickCircle} alt="Check" className="list-data"/>Virtual one-on-one mentoring</li>
        <li className="d-flex align-items-start gap-2"><img src={TickCircle} alt="Check" className="list-data"/>24/7 technical support</li>
      </ul>
    ),
    color: "#141414",
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
];

const testData = {
  title: 'Why NSW Students Trust Our<br/>',
  highlight: "PTE Coaching Programs",
  bottomDescription: 'We help students across New South Wales prepare strategically<br/>with structured guidance and consistent feedback. ',
  cta: "Start Your PTE Preparation Today",
  list: [
    "Structured curriculum aligned with PTE scoring logic",
    "Both classroom and online formats available",
    "AI-based mock simulation platform",
    "Dedicated mentorship and consistent feedback",
    "Proven success across NSW",
    "Targeted preparation for 55+, 65+ and 75+ scores",
  ],
};

const sliderList = {
  title: "Success Stories from <span>NSW Students</span>",
  subtitle: "Students across Sydney, Parramatta, Newcastle, Wollongong and regional NSW have achieved significant improvements through our coaching programs.",

  settings: {
    slidesPerView: 3,
    spaceBetween: 20,
    breakpoints: {
      0:    { slidesPerView: 1 },
      768:  { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    },
  },

  items: [
    {
      id: 1,
      name: "Sarah M.",
      location: "Liverpool, NSW",
      description:
        "Jumped from 58 to 79 in just 6 weeks! The personalised feedback was incredible.",
      image: Profile,
    },
    {
      id: 2,
      name: "Raj P.",
      location: "Newcastle, NSW",
      description:
        "Online classes were perfect for my schedule. Achieved 65+ and got my visa approved!",
      image: Profile,
    },
    {
      id: 3,
      name: "Chen L.",
      location: "Parramatta, NSW",
      description:
        "Failed PTE twice before finding this institute. Finally got 72 overall!",
      image: Profile,
    },
    {
      id: 4,
      name: "Maria S.",
      location: "Wollongong, NSW",
      description:
        "Best investment ever. From 45 to 68 in two months. University admission secured!",
      image: Profile,
    },
  ],
};

const faqQuestions = [
  {
    question: "How long does PTE preparation take? ",
    answer:
      "Preparation time varies by current English level and target score. Most students achieve their goals within 4 to 12 weeks with consistent practice and expert guidance.",
  },
  {
    question: "What's included in your PTE coaching classes in NSW? ",
    answer:
      "Complete packages include expert instruction, comprehensive materials, unlimited mock tests, personal feedback, and online resources.",
  },
  {
    question: "How effective is online PTE coaching compared to classroom learning? ",
    answer:
      "Our online PTE Academic coaching delivers an identical curriculum and results. 82% of online students achieve target scores, with added flexibility for busy schedules.",
  },
  {
    question: "What makes your institute the best PTE coaching in NSW? ",
    answer:
      "Our combination of expert trainers, proven methodologies, comprehensive resources, flexible learning options, and outstanding success rates sets us apart.",
  },
  {
    question: "Do you provide study materials for PTE preparation in NSW? ",
    answer:
      "Yes — all students receive premium study materials, including online resources, a mobile app, and access to extensive question banks.",
  },
  {
    question: "How much do your PTE coaching classes in NSW cost? ",
    answer:
      "We offer customised programs for both online and offline formats to match your specific needs and goals. Contact us for detailed information about our current packages and special offers.",
  },
];

const openPopup = () => {
  const modal = new window.bootstrap.Modal(
    document.getElementById("staticBackdrop")
  );
  modal.show();
};

const tableData = [
  {
    id: 1,
    img: Document,
    hoverImg: GreenDocument,
    badge: "Beginners",
    title: "Online Foundation",
    text: "Core modules + practice",
    btnText: "Enroll Now",
    width: "28px",
    height: "28px",
    link: "/auth/register",
  },
  {
    id: 2,
    img: Document,
    hoverImg: GreenDocument,
    badge: "65+ & 79+ targets",
    title: "Advanced Target Batch",
    text: "Intensive coaching + mocks",
    btnText: "Join Today",
    width: "28px",
    height: "28px",
    link: "/auth/register",
  },
  {
    id: 3,
    img: Document,
    hoverImg: GreenDocument,
    badge: "Fast-track students",
    title: "One-On-One Mentoring",
    text: "Personal strategy + direct feedback",
    btnText: "Book Consultation",
    width: "28px",
    height: "28px",
    link: openPopup,
  },
];

const NSW = () => {
  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const heroWorkTitle = () => (
    <h1 className="FS48 fw-500 top-section-text">
      <span className="text-success fw-600">PTE Coaching Classes in NSW - <br/></span>
      Master English Proficiency with <br/>Expert Guidance
    </h1>
  );

  const heroData = {
    badge: "50,000+ Students' Success Stories",
    title: heroWorkTitle,
    subtitle:
      "Professional PTE Academic Coaching Across New South Wales – Online & Classroom Training in Sydney, Parramatta, Liverpool, Blacktown, Penrith, Newcastle, Wollongong & Regional NSW",
    btn_prepration: {
      text: "Book Your Free PTE Assessment",
      onClick: openPopup,
    },
    btn_outline: {
      text: "Demo Class",
      variant: "outline",
      onClick: openPopup,
    },
    users: [
      "/images/web-new-images/new-content-slider/User-01.svg",
      "/images/web-new-images/new-content-slider/User-02.svg",
      "/images/web-new-images/new-content-slider/User-03.svg",
      "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
    ],
    trustText: "Trusted by 50,000+ students",
    profile: {
      image: "/images/web-new-images/new-content-slider/Varun-sir-hero.webp",
      stats: [
        { value: "50K+", label: "STUDENTS" },
        { value: "95%", label: "SUCCESS RATE" },
        { value: "10+", label: "LOCATIONS" },
      ],
    },
    bottomStats: [
      { value: "8", highlight: "+", label: "Years of PTE Expertise" },
      { value: "30", highlight: "+", label: "Countries Served" },
      { value: "/5", highlight: "4.8", label: "Rated PTE Practice App" },
      { value: "-Powered", highlight: "AI", label: "Scoring Engine" },
    ],
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Trusted PTE, IELTS and NAATI Coaching New South Wales</title>
        <meta
          name="description"
          content="Enrol in LA Language Academy for trusted PTE, IELTS and NAATI coaching across New South Wales. Learn with experts, AI scoring and real exam practice materials."
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.languageacademy.com.au/city/newsouthwales"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta
          name="twitter:title"
          content="Trusted PTE, IELTS and NAATI Coaching New South Wales"
        />
        <meta
          name="twitter:description"
          content="Enrol in LA Language Academy for trusted PTE, IELTS and NAATI coaching across New South Wales. Learn with experts, AI scoring and real exam practice materials."
        />
        <meta
          name="twitter:image"
          content="https://www.languageacademy.com.au/images/logol.png"
        />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta
          property="og:url"
          content="https://www.languageacademy.com.au/city/newsouthwales"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Trusted PTE, IELTS and NAATI Coaching New South Wales"
        />
        <meta
          property="og:description"
          content="Enrol in LA Language Academy for trusted PTE, IELTS and NAATI coaching across New South Wales. Learn with experts, AI scoring and real exam practice materials."
        />
        <meta
          property="og:image"
          content="https://www.languageacademy.com.au/images/logol.png"
        />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design">
        <Header />
        <HeroSectionUpdated data={heroData} />

        <div className="fame-wall off-white">
          <ReusableHomePageSlider images={images} />
        </div>

        <div className="d-flex align-items-center gap-4 flex-column pb-4 off-white">
          {heroDescriptionSection()}
          <ButtonComp
            link={openPopup}
            btnText={"Book Your Free PTE Assessment"}
            img={"/images/web-new-images/new-dark-arrow.svg"}
          />
        </div>

        <PteConsultation />

        <div className="custom-container py-5">
          <ContentImageSection
            contentSection={contentSection}
            quoteText={
              "Ready to achieve your dream PTE score? Our specialised <span class='plus-sans fw-700 FS18FW400'>PTE preparation NSW</span> programs deliver exceptional results for students across New South Wales. From bustling <span class='plus-sans fw-700 FS18FW400'>Sydney</span> to scenic <span class='plus-sans fw-700 FS18FW400'>Newcastle</span> and growing <span class='plus-sans fw-700 FS18FW400'>Wollongong</span>, we provide comprehensive <span class='plus-sans fw-700 FS18FW400'>PTE Academic coaching in NSW</span> designed to maximize your success."
            }
            btnLink={openPopup}
            btnText="Get Your Free PTE Score Assessment Now"
            btnClassName="mt-4"
            image={Immigration}
            imageClassName="immigration-test-img"
            reverse={true}
            // paragraphs={[
            //   "From bustling Sydney to scenic Newcastle and growing Wollongong, we provide comprehensive PTE Academic coaching in NSW designed to maximise your success.",
            // ]}
            listSectionTitle="<span class='plus-sans fw-700 FS18FW400'>Why Thousands Choose Our PTE Training:</span>"
            listColumns={[
              [
                "<span class='plus-sans fw-700 FS18FW400'>85% of students achieve their target score</span> on the first attempt",
                "<span class='plus-sans fw-700 FS18FW400'>Expert trainers </span> with proven track records",
                "<span class='plus-sans fw-700 FS18FW400'>Flexible learning options </span>– classroom and online formats",
                "<span class='plus-sans fw-700 FS18FW400'>Comprehensive study materials </span>and unlimited practice tests",
              ],
            ]}
            listSingleColumn
          />
        </div>

        <SkillAreas
          skillAreaTitle={skillAreaTitle}
          lifestyleCards={lifestyleCards}
          btnText={"Book a Free PTE Demo Class"}
          btnLink={openPopup}
          img={"/images/web-new-images/new-dark-arrow.svg"}
          skillSubtitle={
            "Experience our teaching style through structured tutorial sessions designed to simplify complex question types and improve scoring techniques."
          }
          noTilt
          padding={"p-80"}
        />
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle2}
          lifestyleCards={styleCards}
          leftSection={false}
          center={"d-flex justify-content-center text-center"}
          noTilt
          btnText2={"Enroll in Our PTE Online Caching NSW Program"}
        />
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle3}
          lifestyleCards={styleCards2}
          skillCardClass={
            styleCards2.length <= 4
              ? `col-md-6 col-lg-${12 / styleCards2.length} d-flex`
              : "col-md-6 col-lg-3 d-flex"
          }
          skillSubtitle={
            "Every section of our PTE coaching in NSW is designed for high-score achievement, with structured modules for steady progress."
          }
          noTilt
          padding="pb-0"
        />

        <div className="custom-container py-5">
          <div className="d-flex justify-content-center text-center mb-5">
            {skillAreaTitle4()}
          </div>
          <div className="course-card-data">
            {tableData.map((card, index) => (
              <CourseCard key={card.id} card={card} index={index} />
            ))}
          </div>
          <div className="d-flex justify-content-center mt-5">
            <ButtonComp
              link={openPopup}
              btnText={"Get Personalised Score Strategy – Free Consultation"}
              className={"mt-4"}
            />
          </div>
        </div>

        <div className="mt-4">
          <TestimonialSection
            extraClass={"flex-column flex-lg-row flex-lg-row text-start"}
            extraWidth={"700px"}
            title={`<span class="hero-title FS40FW600 mb-0">Success Stories from <br/><span class="green-text">NSW Students</span></span>`}
            subtitle={
              "<span style={{maxWidth: '700px'}}>Students across Sydney, Parramatta, Newcastle, Wollongong and regional NSW have achieved significant improvements through our coaching programs.</span>"
            }
            showBtn={true}
            sliderList={sliderList}
            btnText={"Join Our Success Community Today"}
            titleClass={"text-start"}
          />
        </div>

        <TestSection
          data={testData}
          bgColor="#080F1E"
          extraClass={"custom-list-spacing"}
        />

        <div style={{ padding: "40px 0 30px 0" }}>
          <CtaBanner
            title="Take the First Step Toward Your"
            highlight="Target Score"
            buttonText="Book Free Consultation"
            onClick={openPopup}
            rightImage="/images/web-new-images/HomePageImage/CTA-Image.webp"
            btnText="Take Free Mock Test Now"
            subTitle={
              "Know your current level before enrolling – identify weak sections, receive a detailed performance breakdown, and get a personalised improvement roadmap."
            }
          />
        </div>

        <FaqSection questions={faqQuestions} />

        <CTAContactSection
          heading={
            <>
              Get Your{" "}
              <span className="text-success FS40FW600">
see                Customised PTE Program Quote
              </span>{" "}
              for NSW Today
            </>
          }
          subHeading="Every student's journey is unique. Let us design the perfect PTE preparation program for your specific needs and budget."
          topRowCards={[
            {
              title: "Phone / WhatsApp",
              icon: IconCall,
              content: (
                <p style={{ fontSize: "15px", fontWeight: 700, color: "#fff", margin: 0 }}>
                  +61 426 230 061
                </p>
              ),
            },
            {
              title: "Email",
              icon: IconEmail,
              content: (
                <p style={{ fontSize: "15px", fontWeight: 700, color: "#fff", margin: 0 }}>
                  info@languageacademy.com.au
                </p>
              ),
            },
            {
              title: "WhatsApp",
              icon: IconChats,
              content: (
                <p style={{ fontSize: "15px", fontWeight: 700, color: "#fff", margin: 0 }}>
                  Quick consultation available
                </p>
              ),
            },
            {
              title: "Walk-in",
              icon: IconLocation,
              content: (
                <p style={{ fontSize: "15px", fontWeight: 700, color: "#fff", margin: 0 }}>
                  Visit any of our <a href="/branches" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "underline" }}>centres</a>
                </p>
              ),
            },
          ]}
          bottomRowCards={[
            {
              title: "Consultation Hours",
              icon: IconClock,
              content: (
                <ul style={{ margin: 0, padding: "0 0 0 18px", display: "flex", flexDirection: "column", gap: "6px" }}>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    Monday–Thursday: 9:00 AM – 5:00 PM
                  </li>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    Saturday: 9:00 AM – 5:00 PM
                  </li>
                </ul>
              ),
            },
            {
              title: "Instant Response",
              icon: IconInfo,
              content: (
                <ul style={{ margin: 0, padding: "0 0 0 18px", display: "flex", flexDirection: "column", gap: "6px" }}>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    Call <a href="tel:+61426230061" style={{ color: "#fff", textDecoration: "underline" }}>+61 426 230 061</a> for immediate assistance
                  </li>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    WhatsApp <a href="https://wa.me/61426230061" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "underline" }}>+61 426 230 061</a> for quick queries
                  </li>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    Email <a href="mailto:info@languageacademy.com.au" style={{ color: "#fff", textDecoration: "underline" }}>info@languageacademy.com.au</a> for detailed inquiries
                  </li>
                </ul>
              ),
            },
          ]}
          cta={{
            label: "Schedule Your Free Consultation – Discover Your Perfect Program",
            onClick: openPopup,
          }}
        />

        <Footer />
      </div>
    </React.Fragment>
  );
};

export default NSW;
